(function() {
  'use strict';

  var COOKIE_NAME = 'cv_location';
  var COOKIE_DAYS = 3650;
  var GT_OFFSET = -6;

  var _xelaTextOriginal = null;

  function _updateXelaTexts() {
    document.querySelectorAll('[data-xela-badge-text]').forEach(function(el) {
      if (!el.getAttribute('data-xela-original')) {
        el.setAttribute('data-xela-original', el.textContent.trim());
      }
      var original = el.getAttribute('data-xela-original');
      if (document.documentElement.classList.contains('cv-xela-green')) {
        el.textContent = original.replace(/\s*\(24\s*hr\)\s*/i, '').replace(/\s*24\s*hr\s*/i, '').trim();
      } else {
        el.textContent = original;
      }
    });
  }

  function _handleDualContainers(dept, zone) {
    var isXelaZone = zone === 'messenger_xela';
    var isSharedZone = zone === 'messenger_both';
    document.querySelectorAll('.xela-stock-dual').forEach(function(dual) {
      var stockGt = dual.getAttribute('data-stock-gt') === 'true';
      var stockEl = dual.querySelector('.xela-stock-dual__stock');
      var xelaEl = dual.querySelector('.xela-stock-dual__xela');
      if (!stockEl || !xelaEl) return;
      if (isSharedZone) {
        // An overlap is not a warehouse decision: present both availability
        // signals rather than implying that one of them will fulfill it.
        stockEl.style.setProperty('display', 'inline-flex', 'important');
        xelaEl.style.setProperty('display', 'inline-flex', 'important');
      } else if (isXelaZone) {
        stockEl.style.setProperty('display', 'none', 'important');
        xelaEl.style.setProperty('display', 'inline-flex', 'important');
      } else if (stockGt) {
        stockEl.style.setProperty('display', 'inline-flex', 'important');
        xelaEl.style.setProperty('display', 'none', 'important');
      } else {
        stockEl.style.setProperty('display', 'none', 'important');
        xelaEl.style.setProperty('display', 'inline-flex', 'important');
      }
    });
  }

  function _resetDualContainers() {
    document.querySelectorAll('.xela-stock-dual').forEach(function(dual) {
      var stockEl = dual.querySelector('.xela-stock-dual__stock');
      var xelaEl = dual.querySelector('.xela-stock-dual__xela');
      if (stockEl) stockEl.style.removeProperty('display');
      if (xelaEl) xelaEl.style.removeProperty('display');
    });
  }

  function _handleGtOnlyBadges(zone) {
    var isXelaZone = zone === 'messenger_xela';
    document.querySelectorAll('[data-gt-only="true"]').forEach(function(badge) {
      var textEl = badge.querySelector('.stock-badge-text');
      var iconEl = badge.querySelector('.stock-icon-svg');
      if (!textEl) return;
      if (isXelaZone) {
        if (!badge.getAttribute('data-gt-only-original')) {
          badge.setAttribute('data-gt-only-original', textEl.textContent.trim());
        }
        textEl.textContent = 'Envío desde Guate';
        badge.classList.add('product-label--gt-only');
        if (iconEl) iconEl.style.setProperty('display', 'none', 'important');
      } else {
        var orig = badge.getAttribute('data-gt-only-original');
        if (orig) textEl.textContent = orig;
        badge.classList.remove('product-label--gt-only');
        if (iconEl) iconEl.style.removeProperty('display');
      }
    });
  }

  function _resetGtOnlyBadges() {
    document.querySelectorAll('[data-gt-only="true"]').forEach(function(badge) {
      var textEl = badge.querySelector('.stock-badge-text');
      var iconEl = badge.querySelector('.stock-icon-svg');
      if (!textEl) return;
      var orig = badge.getAttribute('data-gt-only-original');
      if (orig) textEl.textContent = orig;
      badge.classList.remove('product-label--gt-only');
      if (iconEl) iconEl.style.removeProperty('display');
    });
  }

  function _resetStandaloneXelaBadges() {
    document.querySelectorAll('[data-xela-badge][data-stock-gt]').forEach(function(badge) {
      if (badge.closest('.xela-stock-dual')) return;
      badge.style.removeProperty('display');
    });
  }

  // Misma regla que _handleDualContainers: con existencia en Guatemala se envía
  // desde Guatemala (también por Cargo Expreso a otros departamentos), salvo en
  // la zona de mensajero de Xela o la compartida. Antes solo se ocultaba con el
  // departamento Guatemala, y en Escuintla el carrito decía "Envío de Xela".
  function _handleStandaloneXelaBadges(dept, zone) {
    document.querySelectorAll('[data-xela-badge][data-stock-gt]').forEach(function(badge) {
      if (badge.closest('.xela-stock-dual')) return;
      var stockGt = badge.getAttribute('data-stock-gt') === 'true';
      if (zone === 'messenger_both' || zone === 'messenger_xela' || !stockGt) {
        badge.style.removeProperty('display');
      } else {
        badge.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Marca "ubicación exacta" (GPS o pin en el mapa), distinta de elegir sólo
  // departamento/municipio en el selector del header (loc.precise === false).
  function applyExactLocationClass(loc) {
    var root = document.documentElement;
    if (loc && loc.confirmed && loc.precise) {
      root.classList.add('cv-has-exact-location');
    } else {
      root.classList.remove('cv-has-exact-location');
    }
  }

  function applyXelaBadgeLogic(loc) {
    var root = document.documentElement;
    root.classList.remove('cv-xela-green', 'cv-xela-local');
    applyExactLocationClass(loc);
    if (!loc || !loc.confirmed) {
      root.classList.remove('cv-has-location');
      _resetDualContainers();
      _resetStandaloneXelaBadges();
      _resetGtOnlyBadges();
      _updateXelaTexts();
      return;
    }
    root.classList.add('cv-has-location');
    var dept = (loc.dept || '').toLowerCase().trim();
    var zone = (loc.zone || '').toLowerCase().trim();
    if (zone === 'unknown' || zone === 'outside') {
      _resetDualContainers();
      _resetStandaloneXelaBadges();
      _resetGtOnlyBadges();
      _updateXelaTexts();
      return;
    }
    if (dept === 'guatemala') {
      _handleDualContainers(dept, zone);
      _handleStandaloneXelaBadges(dept, zone);
      _handleGtOnlyBadges(zone);
      _updateXelaTexts();
      return;
    }
    root.classList.add('cv-xela-green');
    if (zone === 'messenger_xela') {
      root.classList.add('cv-xela-local');
    }
    _handleDualContainers(dept, zone);
    _handleStandaloneXelaBadges(dept, zone);
    _handleGtOnlyBadges(zone);
    _updateXelaTexts();
  }

  var _xelaObserverTimer = null;
  if (typeof MutationObserver !== 'undefined') {
    var _xelaObserver = new MutationObserver(function(mutations) {
      var root = document.documentElement;
      var hasLocation = root.classList.contains('cv-has-location');
      var isLocal = root.classList.contains('cv-xela-local');
      if (!hasLocation && !isLocal) return;
      var hasNew = false;
      for (var i = 0; i < mutations.length && !hasNew; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            if ((node.hasAttribute && (node.hasAttribute('data-xela-badge-text') || node.hasAttribute('data-xela-badge') || node.classList.contains('xela-stock-dual') || node.hasAttribute('data-gt-only'))) ||
                (node.querySelector && (node.querySelector('[data-xela-badge-text]') || node.querySelector('.xela-stock-dual') || node.querySelector('[data-gt-only]')))) {
              hasNew = true;
              break;
            }
          }
        }
      }
      if (hasNew) {
        if (_xelaObserverTimer) clearTimeout(_xelaObserverTimer);
        _xelaObserverTimer = setTimeout(function() {
          try {
            var match = document.cookie.match('(?:^|;)\\s*' + COOKIE_NAME + '=([^;]*)');
            if (match) {
              var d = JSON.parse(decodeURIComponent(match[1]));
              if (d && d.confirmed) {
                applyXelaBadgeLogic(d);
              }
            }
          } catch(e) {}
          _updateXelaTexts();
        }, 50);
      }
    });
    if (document.body) {
      _xelaObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        _xelaObserver.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  document.addEventListener('cv:location-changed', function(e) {
    if (e.detail) applyXelaBadgeLogic(e.detail);
  });
  document.addEventListener('cv:location-ready', function(e) {
    if (e.detail) applyXelaBadgeLogic(e.detail);
  });

  (function() {
    try {
      var match = document.cookie.match('(?:^|;)\\s*' + COOKIE_NAME + '=([^;]*)');
      if (match) {
        var d = JSON.parse(decodeURIComponent(match[1]));
        if (d && d.confirmed) {
          document.documentElement.classList.add('cv-has-location');
          if (d.precise) document.documentElement.classList.add('cv-has-exact-location');
          // A persisted zone belongs to an older coverage configuration until
          // init reclassifies its coordinates through CelovendoCoverage.
          d.zone = 'unknown';
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() { applyXelaBadgeLogic(d); });
          } else {
            applyXelaBadgeLogic(d);
          }
        }
      }
    } catch(e) {}
  })();
  var DEFAULT_LOCATION = {
    dept: 'Guatemala',
    muni: 'Guatemala',
    lat: 14.6349,
    lng: -90.5069,
    zone: 'messenger_ciudad'
  };

  var DAYS_ES = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MONTHS_ES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var MONTHS_SHORT_ES = ['ene.','feb.','mar.','abr.','may.','jun.','jul.','ago.','sep.','oct.','nov.','dic.'];

  function getNowGT() {
    var now = new Date();
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utc + GT_OFFSET * 3600000);
  }

  function pointInPolygon(point, polygon) {
    var x = point[0], y = point[1];
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var xi = polygon[i][0], yi = polygon[i][1];
      var xj = polygon[j][0], yj = polygon[j][1];
      var intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function pointInGeometry(lng, lat, geometry) {
    var coverage = window.CelovendoCoverage;
    if (coverage && typeof coverage.contains === 'function') {
      return coverage.contains(lng, lat, geometry);
    }
    var point = [lng, lat];
    if (geometry.type === 'Polygon') {
      return pointInPolygon(point, geometry.coordinates[0]);
    } else if (geometry.type === 'MultiPolygon') {
      for (var p = 0; p < geometry.coordinates.length; p++) {
        if (pointInPolygon(point, geometry.coordinates[p][0])) return true;
      }
    }
    return false;
  }

  var geoCache = {};

  function loadGeoJSON(url) {
    if (geoCache[url]) return Promise.resolve(geoCache[url]);
    return fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        geoCache[url] = data;
        return data;
      });
  }

  function findCityZone(lat, lng, config) {
    var urls = config.geoJsonUrls;
    if (!urls.zonasCiudad) return Promise.resolve(null);
    return loadGeoJSON(urls.zonasCiudad).then(function(data) {
      for (var i = 0; i < data.features.length; i++) {
        var feat = data.features[i];
        if (pointInGeometry(lng, lat, feat.geometry)) {
          return feat.properties.name || null;
        }
      }
      return null;
    }).catch(function() { return null; });
  }

  function normalizeCoverageZone(classification, municipality) {
    if (!classification) return 'unknown';
    function canonical(value) {
      return String(value || '').toLowerCase().trim()
        .replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i')
        .replace(/ó/g, 'o').replace(/ú/g, 'u')
        .replace(/[\s-]+/g, '_');
    }

    var status = canonical(classification.delivery_coverage_status);
    var deliveryZone = canonical(classification.delivery_zone);
    var deliveryMethod = canonical(classification.delivery_method);
    if (status === 'unknown' || status === 'error' || status === 'unavailable' ||
        deliveryZone === 'unknown') return 'unknown';
    if (status === 'outside' || status === 'out_of_coverage' || status === 'not_covered') return 'outside';

    // These are the engine's canonical enums. Do not use a truthy zone to
    // hide the verified method: `fuera` is a Cargo route, while `ambas`
    // deliberately has no warehouse-specific promise.
    if (deliveryZone === 'ambas' || deliveryZone === 'messenger_both' || deliveryZone === 'both') {
      return 'messenger_both';
    }
    if (deliveryZone === 'fuera') {
      return deliveryMethod === 'cargo' || deliveryMethod === 'cargo_expreso' ? 'cargo_expreso' : 'unknown';
    }
    if (deliveryMethod === 'cargo' || deliveryMethod === 'cargo_expreso') return 'cargo_expreso';

    if (deliveryZone === 'xela' || deliveryZone === 'messenger_xela' ||
        deliveryZone === 'xela_messenger' || deliveryZone === 'messenger_quetzaltenango') {
      return deliveryMethod === 'mensajero' || deliveryMethod === 'messenger' || !deliveryMethod
        ? 'messenger_xela' : 'unknown';
    }
    if (deliveryZone === 'messenger_ciudad' || deliveryZone === 'guatemala_city') return 'messenger_ciudad';
    if (deliveryZone === 'guatemala' || deliveryZone === 'messenger_guatemala' ||
        deliveryZone === 'guatemala_messenger' || deliveryZone === 'messenger') {
      if (deliveryMethod && deliveryMethod !== 'mensajero' && deliveryMethod !== 'messenger') return 'unknown';
      return municipality && municipality.toLowerCase() === 'guatemala' ? 'messenger_ciudad' : 'messenger';
    }
    return 'unknown';
  }

  function findDeliveryZone(lat, lng, config) {
    var coverage = window.CelovendoCoverage;
    if (!coverage || typeof coverage.load !== 'function' || typeof coverage.classify !== 'function') {
      return Promise.reject(new Error('El servicio de cobertura no está disponible.'));
    }

    function municipalityAt(municipios) {
      var municipio = null;
      var departamento = null;
      for (var i = 0; i < municipios.features.length; i++) {
        var feat = municipios.features[i];
        if (pointInGeometry(lng, lat, feat.geometry)) {
          municipio = feat.properties.municipio || feat.properties.MUNICIPIO || '';
          departamento = feat.properties.departamen || feat.properties.DEPARTAMEN || feat.properties.departamento || '';
          break;
        }
      }
      return { municipio: municipio, departamento: departamento };
    }

    // The coverage engine owns both delivery polygons. Municipalities and city
    // zones remain separate because they are labels, not delivery coverage.
    return Promise.all([
      coverage.load(),
      loadGeoJSON(config.geoJsonUrls.municipios)
    ]).then(function(results) {
      return Promise.resolve(coverage.classify(lat, lng)).then(function(classification) {
        var place = municipalityAt(results[1]);
        var zone = normalizeCoverageZone(classification, place.municipio);
        var zoneInfo = {
          zone: zone,
          municipio: place.municipio,
          departamento: place.departamento,
          cityZone: null,
          coverage: classification
        };
        if (zone === 'messenger_ciudad') {
          return findCityZone(lat, lng, config).then(function(cityZone) {
            zoneInfo.cityZone = cityZone;
            return zoneInfo;
          });
        }
        return zoneInfo;
      });
    });
  }

  function getCentroid(geometry) {
    var coords;
    if (geometry.type === 'Polygon') {
      coords = geometry.coordinates[0];
    } else if (geometry.type === 'MultiPolygon') {
      coords = geometry.coordinates[0][0];
    } else {
      return null;
    }
    var sumLng = 0, sumLat = 0;
    for (var i = 0; i < coords.length; i++) {
      sumLng += coords[i][0];
      sumLat += coords[i][1];
    }
    return [sumLat / coords.length, sumLng / coords.length];
  }

  function isValidTime(str) {
    if (!str || str === 'cerrado') return false;
    var parts = str.split(':');
    if (parts.length !== 2) return false;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    return !isNaN(h) && !isNaN(m) && h >= 0 && h <= 23 && m >= 0 && m <= 59;
  }

  function parseBusinessHours(config) {
    var days = ['sun','mon','tue','wed','thu','fri','sat'];
    var hours = {};
    for (var i = 0; i < days.length; i++) {
      var d = days[i];
      var open = config.hours[d + '_open'] || '';
      var close = config.hours[d + '_close'] || '';
      if (isValidTime(open) && isValidTime(close)) {
        hours[i] = {
          open: parseTime(open),
          close: parseTime(close)
        };
      } else {
        hours[i] = null;
      }
    }
    return hours;
  }

  function parseTime(str) {
    var parts = str.split(':');
    return { h: parseInt(parts[0], 10), m: parseInt(parts[1], 10) };
  }

  function timeToMinutes(t) {
    return t.h * 60 + t.m;
  }

  function isBusinessDay(date, bh) {
    return bh[date.getDay()] !== null;
  }

  function addBusinessDays(date, days, bh) {
    var result = new Date(date.getTime());
    result.setHours(0, 0, 0, 0);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result, bh)) added++;
    }
    return result;
  }

  function nextBusinessOpen(date, bh, cutoff) {
    cutoff = cutoff || 0;
    var d = new Date(date.getTime());
    var dayInfo = bh[d.getDay()];
    if (dayInfo) {
      var nowMin = d.getHours() * 60 + d.getMinutes();
      var effectiveClose = timeToMinutes(dayInfo.close) - cutoff;
      if (nowMin < effectiveClose) {
        if (nowMin >= timeToMinutes(dayInfo.open)) {
          return d;
        } else {
          d.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
          return d;
        }
      }
    }
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    for (var attempt = 0; attempt < 14; attempt++) {
      var info = bh[d.getDay()];
      if (info) {
        d.setHours(info.open.h, info.open.m, 0, 0);
        return d;
      }
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  // productType: immediate | backorder | slowback | xela | marketplace.
  // days: días hábiles del tipo (data-delivery-days, desde snippets/cv-delivery-type.liquid).
  // Sin valor, backorder usa 7 y slowback 10. marketplace siempre llega por Cargo Expreso.
  function calculateEstimate(zoneInfo, productType, config, now, days) {
    if (!now) now = getNowGT();
    var bh = parseBusinessHours(config);
    var cutoff = parseInt(config.cutoff, 10) || 0;
    var baseDate = new Date(now.getTime());
    var leadDays = parseInt(days, 10);

    if (productType === 'backorder' || productType === 'slowback') {
      if (!(leadDays > 0)) leadDays = productType === 'slowback' ? 10 : 7;
      baseDate = addBusinessDays(now, leadDays, bh);
      baseDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    }

    var zone = zoneInfo.zone;
    var result = {};

    // Marketplace y bajo pedido van solo por Cargo Expreso, en cualquier zona, como
    // en el checkout. Bajo pedido ya corrió sus días en baseDate y tarda uno más;
    // marketplace usa sus días como tránsito.
    if (productType === 'marketplace' || productType === 'backorder' || productType === 'slowback') {
      var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
      var transitDays = productType === 'marketplace' && leadDays > 0 ? leadDays : 1;
      var arrivalDate = addBusinessDays(dispatchDate, transitDays, bh);
      var dayInfo = bh[arrivalDate.getDay()];
      if (dayInfo) {
        arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
      }
      result.method = 'Cargo Expreso';
      result.date = arrivalDate;
      result.type = 'cargo';
    } else if (productType === 'xela') {
      if (zone === 'messenger_xela') {
        var minutes = parseInt(config.minutes.messenger_xela, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger_ciudad' || zone === 'messenger' || zone === 'cargo_expreso') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else {
        return null;
      }
    } else {
      if (zone === 'messenger_ciudad') {
        var minutes = parseInt(config.minutes.messenger_ciudad, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger') {
        var minutes = parseInt(config.minutes.messenger, 10) || 90;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger_xela') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else if (zone === 'cargo_expreso') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else {
        return null;
      }
    }

    var locLabel = zoneInfo.cityZone || zoneInfo.municipio || '';
    if (locLabel) locLabel = shortenMuniName(locLabel);
    result.formatted = formatDate(result.date, result.type, locLabel);
    result.formattedRange = formatRange(result.date, result.type, locLabel, bh, now);
    result.municipio = zoneInfo.municipio;
    result.departamento = zoneInfo.departamento;
    return result;
  }

  function shortenMuniName(name) {
    if (!name) return name;
    var s = name;
    s = s.replace(/^(El|La)\s+/i, '');
    s = s.replace(/\bSanta\s+/g, 'Sta. ');
    s = s.replace(/\bSanto\s+/g, 'Sto. ');
    s = s.replace(/\bSan\s+/g, 'S. ');
    var words = {
      'Pedro':'P.','José':'J.','Jose':'J.','Juan':'J.','Marcos':'M.',
      'Pablo':'P.','Francisco':'F.','Miguel':'M.','Antonio':'A.',
      'Martín':'M.','Martin':'M.','Lucas':'L.','Bartolomé':'B.',
      'Bartolome':'B.','Cristóbal':'C.','Cristobal':'C.','Andrés':'A.',
      'Andres':'A.','Mateo':'M.','Felipe':'F.','Bernardino':'B.',
      'Agustín':'A.','Agustin':'A.','Raymundo':'R.','Benito':'B.'
    };
    Object.keys(words).forEach(function(w) {
      s = s.replace(new RegExp('\\b' + w + '\\b', 'g'), words[w]);
    });
    return s.replace(/\s{2,}/g, ' ').trim();
  }

  function formatDate(date, type, locationLabel) {
    var now = getNowGT();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffDays = Math.round((dateDay - today) / 86400000);

    var dayName;
    if (diffDays === 0) {
      dayName = 'hoy';
    } else if (diffDays === 1) {
      dayName = 'mañana';
    } else if (diffDays === 2) {
      dayName = 'pasado mañana, ' + DAYS_ES[date.getDay()];
    } else {
      dayName = 'el ' + DAYS_ES[date.getDay()] + ' ' + date.getDate() + ' de ' + MONTHS_ES[date.getMonth()];
    }

    var suffix = locationLabel ? ' en ' + locationLabel : '';

    if (type === 'messenger' && diffDays <= 1) {
      var hours = date.getHours();
      var mins = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var h12 = hours % 12;
      if (h12 === 0) h12 = 12;
      var timeStr = h12 + ':' + (mins < 10 ? '0' : '') + mins + ' ' + ampm;
      return 'Recíbelo ' + dayName + ' a las ' + timeStr + suffix;
    } else {
      return 'Recíbelo ' + dayName + suffix;
    }
  }

  // Ancho de la ventana del mensajero: el mismo delivery_margin_minutes (60 por
  // defecto) del servicio de tarifas, para que el carrito y el checkout prometan
  // la misma hora.
  var MESSENGER_WINDOW_MINUTES = 60;

  // Sube a la siguiente hora en punto (11:30 -> 12:00; 11:00 se queda).
  function ceilHour(date) {
    var d = new Date(date.getTime());
    if (d.getMinutes() || d.getSeconds() || d.getMilliseconds()) d.setHours(d.getHours() + 1);
    d.setMinutes(0, 0, 0);
    return d;
  }

  function hourLabel(date) {
    return date.getHours() % 12 || 12;
  }

  /*
   * Texto del carrito como rango, con las reglas del servicio de tarifas (lo que
   * dice el checkout). Mensajero hoy o mañana: una ventana en horas en punto,
   * "Recíbelo hoy de 2 a 3pm en Zona 4"; se redondea hacia arriba para que el
   * fin nunca quede antes de lo estimado. Lo demás (Cargo Expreso, bajo
   * pedido): del día estimado al siguiente día hábil, corto para que quepa en
   * el carrito: "Recíbelo del martes 6 al 7 de oct. en Cobán". Solo el primer
   * día lleva nombre; su mes solo se repite si cambia ("del sábado 31 de oct.
   * al 2 de nov.").
   */
  function formatRange(date, type, locationLabel, bh, now) {
    if (!now) now = getNowGT();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffDays = Math.round((dateDay - today) / 86400000);
    var suffix = locationLabel ? ' en ' + locationLabel : '';

    if (type === 'messenger' && diffDays <= 1) {
      var from = ceilHour(date);
      var to = ceilHour(new Date(from.getTime() + MESSENGER_WINDOW_MINUTES * 60000));
      if (to.getDate() === date.getDate()) {
        var fromPeriod = from.getHours() >= 12 ? 'pm' : 'am';
        var toPeriod = to.getHours() >= 12 ? 'pm' : 'am';
        return 'Recíbelo ' + (diffDays === 0 ? 'hoy' : 'mañana') + ' de ' + hourLabel(from) +
          (fromPeriod === toPeriod ? '' : fromPeriod) + ' a ' + hourLabel(to) + toPeriod + suffix;
      }
    }

    var last = addBusinessDays(date, 1, bh);
    var sameMonth = last.getMonth() === date.getMonth();
    return 'Recíbelo del ' + DAYS_ES[date.getDay()] + ' ' + date.getDate() + (sameMonth ? '' : ' de ' + MONTHS_SHORT_ES[date.getMonth()]) +
      ' al ' + last.getDate() + ' de ' + MONTHS_SHORT_ES[last.getMonth()] + suffix;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(decodeURIComponent(c.substring(nameEQ.length)));
        } catch(e) {
          return null;
        }
      }
    }
    return null;
  }

  function fireLocationEvent(locationData) {
    var evt;
    try {
      evt = new CustomEvent('cv:location-ready', { detail: locationData });
    } catch(e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cv:location-ready', true, true, locationData);
    }
    document.dispatchEvent(evt);
  }

  function fireLocationChangeEvent(locationData) {
    var evt;
    try {
      evt = new CustomEvent('cv:location-changed', { detail: locationData });
    } catch(e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cv:location-changed', true, true, locationData);
    }
    document.dispatchEvent(evt);
  }

  function fireCoverageSyncedLocationEvent(locationData) {
    var eventData = {};
    Object.keys(locationData || {}).forEach(function(key) { eventData[key] = locationData[key]; });
    // Consumers still need the final, resolved location. Engine/cart forwarders
    // use this marker to avoid treating this acknowledgement as a new map pick.
    eventData.coverageSynced = true;
    eventData.source = 'coverage-sync';
    fireLocationChangeEvent(eventData);
  }

  // Departamentos de Guatemala con su código de provincia en Shopify (Admin API countries.json).
  // Los nombres son los de dept-municipios-list.json y municipios.min.json, sin tildes.
  var CHECKOUT_ADDRESS_KEY = 'cv_checkout_address';

  // La dirección del buscador del mapa vale solo para el punto exacto que se eligió con ella:
  // cualquier otra ubicación (mover el pin, GPS, otro municipio) la borra para siempre.
  function dropCheckoutAddressIfMoved(lat, lng) {
    try {
      var saved = JSON.parse(window.localStorage.getItem(CHECKOUT_ADDRESS_KEY) || 'null');
      if (saved && (saved.lat !== Number(lat) || saved.lng !== Number(lng))) {
        window.localStorage.removeItem(CHECKOUT_ADDRESS_KEY);
      }
    } catch (e) {}
  }

  var GT_PROVINCE_CODES = {
    'alta verapaz': 'AVE', 'baja verapaz': 'BVE', 'chimaltenango': 'CMT', 'chiquimula': 'CQM',
    'el progreso': 'EPR', 'escuintla': 'ESC', 'guatemala': 'GUA', 'huehuetenango': 'HUE',
    'izabal': 'IZA', 'jalapa': 'JAL', 'jutiapa': 'JUT', 'peten': 'PET', 'quetzaltenango': 'QUE',
    'quiche': 'QUI', 'el quiche': 'QUI', 'retalhuleu': 'RET', 'sacatepequez': 'SAC',
    'san marcos': 'SMA', 'santa rosa': 'SRO', 'solola': 'SOL', 'suchitepequez': 'SUC',
    'totonicapan': 'TOT', 'zacapa': 'ZAC'
  };

  function plainName(name) {
    var s = String(name || '').toLowerCase().trim();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/\s+/g, ' ');
  }

  var CelovendoLocation = {
    _config: null,
    _location: null,
    _deptMuniList: null,
    _ready: false,
    _locationVersion: 0,
    _geolocationVersion: 0,
    _destinationVersion: 0,
    _coverageRevision: -1,
    _coverageLabelRequest: 0,
    _resolvedDestinationVersions: {},

    _coordinateKey: function(lat, lng) {
      return typeof lat === 'number' && typeof lng === 'number' ? lat + ',' + lng : null;
    },

    _rememberResolvedDestination: function(data, version) {
      var key = this._coordinateKey(data.lat, data.lng);
      if (key) this._resolvedDestinationVersions[key] = version;
      return data;
    },

    getConfig: function() {
      if (this._config) return this._config;
      var el = document.getElementById('cv-location-config');
      if (!el) return null;
      try {
        this._config = JSON.parse(el.textContent);
        return this._config;
      } catch(e) {
        return null;
      }
    },

    getLocation: function() {
      if (this._location) return this._location;
      this._location = getCookie(COOKIE_NAME);
      return this._location;
    },

    // Enlace al checkout con el departamento y el municipio de la ubicación confirmada, para
    // que la dirección de envío ya venga con ellos (parámetros checkout[shipping_address] de
    // Shopify; la provincia necesita el país y el código de Shopify). Si el enlace es el del
    // descuento mayorista (/discount/X?redirect=/checkout), los parámetros van dentro de redirect.
    // Se apaga con el ajuste checkout_prefill_location o si el cliente tiene dirección guardada.
    // Dirección que el cliente escribió o pegó en el buscador del mapa del carrito (no la que el
    // tema pone sola en ese campo). Se guarda con el punto que eligió; si después la ubicación
    // cambia por cualquier otro medio, setLocation la borra y el checkout solo lleva municipio y
    // departamento.
    setCheckoutAddress: function(text, lat, lng) {
      var clean = String(text || '').replace(/\s+/g, ' ').replace(/,\s*Guatemala\s*$/i, '').trim().slice(0, 120);
      try {
        if (clean && typeof lat === 'number' && typeof lng === 'number') {
          window.localStorage.setItem(CHECKOUT_ADDRESS_KEY, JSON.stringify({ text: clean, lat: lat, lng: lng }));
        } else {
          window.localStorage.removeItem(CHECKOUT_ADDRESS_KEY);
        }
      } catch (e) {}
    },

    getCheckoutAddress: function(loc) {
      var saved = null;
      try { saved = JSON.parse(window.localStorage.getItem(CHECKOUT_ADDRESS_KEY) || 'null'); } catch (e) {}
      if (!saved || !saved.text || !loc || typeof loc.lat !== 'number' || typeof loc.lng !== 'number') return '';
      return saved.lat === loc.lat && saved.lng === loc.lng ? saved.text : '';
    },

    checkoutUrl: function(url) {
      var config = this.getConfig();
      var loc = this.getLocation();
      if (!config || config.checkoutPrefill !== true || !loc || !loc.confirmed || !loc.dept) return url;
      var code = GT_PROVINCE_CODES[plainName(loc.dept)];
      if (!code) return url;
      var field = function(name) { return encodeURIComponent('checkout[shipping_address][' + name + ']') + '='; };
      var query = field('country') + 'GT&' + field('province') + code;
      if (loc.muni) query += '&' + field('city') + encodeURIComponent(loc.muni);
      var address = this.getCheckoutAddress(loc);
      if (address) query += '&' + field('address1') + encodeURIComponent(address);
      var redirect = url.match(/([?&]redirect=)([^&#]*)/);
      if (redirect) {
        var target = decodeURIComponent(redirect[2]);
        target += (target.indexOf('?') === -1 ? '?' : '&') + query;
        return url.replace(redirect[0], redirect[1] + encodeURIComponent(target));
      }
      return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
    },

    setLocation: function(dept, muni, lat, lng, zone, cityZone, confirmed, precise, suppressCoverageEvent, authoritativeCoverage) {
      var coordinateKey = this._coordinateKey(lat, lng);
      var resolvedVersion = coordinateKey && this._resolvedDestinationVersions[coordinateKey];
      // Header/map consumers resolve first and set afterwards. Ignore a late
      // resolution if another destination was chosen while it was loading.
      if (!authoritativeCoverage && resolvedVersion && resolvedVersion < this._destinationVersion) {
        delete this._resolvedDestinationVersions[coordinateKey];
        return this._location;
      }
      // A resolved coordinate is a one-shot stale-result token, not a
      // permanent record of where the customer has been. In particular, an
      // authoritative cart snapshot must be allowed to return A after A→B.
      if (resolvedVersion) delete this._resolvedDestinationVersions[coordinateKey];
      var samePoint = this._location && this._location.lat === lat && this._location.lng === lng;
      var samePrecision = this._location && this._location.confirmed === !!confirmed &&
        this._location.precise === !!precise;
      if ((!samePoint || !samePrecision) && (!resolvedVersion || resolvedVersion !== this._destinationVersion)) {
        this._destinationVersion++;
      }
      dropCheckoutAddressIfMoved(lat, lng);
      var loc = { dept: dept, muni: muni, lat: lat, lng: lng, zone: zone || '' };
      if (cityZone) {
        loc.cityZone = cityZone;
      } else if (cityZone === undefined && this._location && this._location.cityZone &&
                 this._location.dept === dept && this._location.muni === muni) {
        loc.cityZone = this._location.cityZone;
      }
      loc.confirmed = (confirmed !== undefined) ? !!confirmed : true;
      // precise === true sólo cuando la ubicación viene de GPS o de un pin exacto
      // en el mapa. El selector de depto/municipio del header NO la pasa.
      loc.precise = !!precise;
      loc.version = ++this._locationVersion;
      this._location = loc;
      setCookie(COOKIE_NAME, loc, COOKIE_DAYS);
      if (loc.confirmed) {
        this._applyLocationBodyClass();
      }
      if (!suppressCoverageEvent) fireLocationChangeEvent(loc);
      this._updateHeaderBadge(loc, loc.confirmed);
      applyXelaBadgeLogic(loc);
      return loc;
    },

    // Texto del pin del encabezado y de su panel: "Zona 10, Guatemala", "Mixco, Guatemala".
    label: function(loc) {
      var place = loc && (loc.cityZone || loc.muni);
      if (!place) return '';
      return loc.dept && loc.dept !== place ? place + ', ' + loc.dept : place;
    },

    _updateHeaderBadge: function(loc, animate) {
      var badgeText = document.querySelector('.capital-badge__text');
      var badge = document.querySelector('.capital-badge');
      var desc = document.getElementById('header-location-desc');
      var pill = document.getElementById('header-location-pill');
      var pillText = pill ? pill.querySelector('.header-location-panel__pill-text') : null;
      if (loc.confirmed) {
        var label = this.label(loc) || 'Guatemala';
        if (badgeText) { badgeText.textContent = label; badgeText.title = label; }
        if (badge) {
          badge.classList.remove('capital-badge--unconfirmed');
          if (animate) {
            badge.classList.remove('capital-badge--location-confirmed');
            void badge.offsetWidth;
            badge.classList.add('capital-badge--location-confirmed');
            setTimeout(function() { badge.classList.remove('capital-badge--location-confirmed'); }, 2200);
          }
        }
        if (desc) desc.style.display = 'none';
        if (pill) { pill.style.display = ''; if (pillText) pillText.textContent = label; }
      } else {
        if (badgeText) { badgeText.textContent = 'Tu ubicación'; badgeText.removeAttribute('title'); }
        if (badge) badge.classList.add('capital-badge--unconfirmed');
        if (desc) desc.style.display = '';
        if (pill) pill.style.display = 'none';
      }
    },

    loadDeptMuniList: function() {
      var self = this;
      if (this._deptMuniList) return Promise.resolve(this._deptMuniList);
      var config = this.getConfig();
      if (!config) return Promise.resolve({});
      return fetch(config.geoJsonUrls.deptMuniList)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          self._deptMuniList = data;
          return data;
        })
        .catch(function() {
          self._deptMuniList = {};
          return {};
        });
    },

    resolveFromCoords: function(lat, lng, requestedDestinationVersion) {
      var self = this;
      var destinationVersion = requestedDestinationVersion || ++this._destinationVersion;
      var config = this.getConfig();
      if (!config) return Promise.reject('No config');
      return findDeliveryZone(lat, lng, config).then(function(zoneInfo) {
        var result = {
          dept: zoneInfo.departamento || DEFAULT_LOCATION.dept,
          muni: zoneInfo.municipio || DEFAULT_LOCATION.muni,
          lat: lat,
          lng: lng,
          zone: zoneInfo.zone
        };
        if (zoneInfo.cityZone) result.cityZone = zoneInfo.cityZone;
        return self._rememberResolvedDestination(result, destinationVersion);
      });
    },

    resolveFromMuni: function(dept, muni) {
      var self = this;
      var destinationVersion = ++this._destinationVersion;
      var config = this.getConfig();
      if (!config) return Promise.reject('No config');
      return loadGeoJSON(config.geoJsonUrls.municipios).then(function(data) {
        var feature = null;
        for (var i = 0; i < data.features.length; i++) {
          var f = data.features[i];
          var fMuni = (f.properties.municipio || f.properties.MUNICIPIO || '').toLowerCase();
          var fDept = (f.properties.departamen || f.properties.DEPARTAMEN || f.properties.departamento || '').toLowerCase();
          if (fMuni === muni.toLowerCase() && fDept === dept.toLowerCase()) {
            feature = f;
            break;
          }
        }
        if (feature) {
          var centroid = getCentroid(feature.geometry);
          var lat = centroid ? centroid[0] : DEFAULT_LOCATION.lat;
          var lng = centroid ? centroid[1] : DEFAULT_LOCATION.lng;
          return findDeliveryZone(lat, lng, config).then(function(zoneInfo) {
            var zone = zoneInfo.zone;
            if (zone === 'outside' || !zone) zone = 'unknown';
            var result = {
              dept: dept,
              muni: muni,
              lat: lat,
              lng: lng,
              zone: zone
            };
            if (zoneInfo.cityZone) result.cityZone = zoneInfo.cityZone;
            return self._rememberResolvedDestination(result, destinationVersion);
          });
        }
        return self._rememberResolvedDestination({
          dept: dept, muni: muni, lat: DEFAULT_LOCATION.lat, lng: DEFAULT_LOCATION.lng, zone: 'unknown'
        }, destinationVersion);
      });
    },

    _showLocationPopup: function() {
      try { if (sessionStorage.getItem('cv_location_popup_shown')) return false; } catch(e) {}
      var pageViews = 1;
      try {
        pageViews = parseInt(sessionStorage.getItem('cv_page_views') || '0', 10) + 1;
        sessionStorage.setItem('cv_page_views', String(pageViews));
      } catch(e) {}
      if (pageViews < 2) return false;
      try { sessionStorage.setItem('cv_location_popup_shown', '1'); } catch(e) {}
      if (window._cvLocPopupOpen) {
        window._cvLocPopupOpen();
      }
      return true;
    },

    _hideLocationPopup: function() {
      var overlay = document.getElementById('cv-location-popup-overlay');
      if (overlay) {
        overlay.style.display = 'none';
        overlay.setAttribute('aria-hidden', 'true');
      }
    },

    _showDeniedState: function() {
      if (window._cvLocShowDenied) {
        window._cvLocShowDenied();
      }
    },

    requestGeolocation: function() {
      var self = this;
      var requestVersion = ++this._geolocationVersion;
      var destinationVersion = ++this._destinationVersion;
      function fallbackUnknownLocation() {
        var key = self._coordinateKey(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng);
        if (key) delete self._resolvedDestinationVersions[key];
        return self.setLocation(DEFAULT_LOCATION.dept, DEFAULT_LOCATION.muni, DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng, 'unknown', undefined, false);
      }
      return new Promise(function(resolve) {
        if (!navigator.geolocation) {
          var loc = fallbackUnknownLocation();
          resolve(loc);
          return;
        }
        navigator.geolocation.getCurrentPosition(function(pos) {
          if (requestVersion !== self._geolocationVersion) {
            resolve(self.getLocation());
            return;
          }
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;
          self.resolveFromCoords(lat, lng, destinationVersion).then(function(locData) {
            if (requestVersion !== self._geolocationVersion) {
              resolve(self.getLocation());
              return;
            }
            if (destinationVersion !== self._destinationVersion) {
              resolve(self.getLocation());
              return;
            }
            if (locData.zone === 'outside') {
              var loc = fallbackUnknownLocation();
              resolve(loc);
            } else {
              var loc = self.setLocation(locData.dept, locData.muni, locData.lat, locData.lng, locData.zone, locData.cityZone, true, true);
              resolve(loc);
            }
          }).catch(function() {
            if (requestVersion !== self._geolocationVersion) {
              resolve(self.getLocation());
              return;
            }
            var loc = fallbackUnknownLocation();
            resolve(loc);
          });
        }, function(err) {
          if (requestVersion !== self._geolocationVersion) {
            resolve(self.getLocation());
            return;
          }
          if (err && err.code === 1) {
            self._showDeniedState();
          }
          var loc = fallbackUnknownLocation();
          resolve(loc);
        }, { enableHighAccuracy: false, timeout: 10000 });
      });
    },

    calculateEstimate: function(productType, days) {
      var loc = this.getLocation();
      var config = this.getConfig();
      if (!loc || !loc.confirmed || !config) return null;
      var zoneInfo = { zone: loc.zone, municipio: loc.muni, departamento: loc.dept, cityZone: loc.cityZone };
      return calculateEstimate(zoneInfo, productType, config, undefined, days);
    },

    _applyLocationBodyClass: function() {
      document.documentElement.classList.add('cv-has-location');
      applyExactLocationClass(this._location);
    },

    _ensureCityZone: function() {
      var self = this;
      var loc = this.getLocation();
      if (!loc || !loc.confirmed || loc.zone !== 'messenger_ciudad' || loc.cityZone || !loc.lat || !loc.lng) return;
      var config = this.getConfig();
      if (!config) return;
      findCityZone(loc.lat, loc.lng, config).then(function(cityZone) {
        if (cityZone) {
          self.setLocation(loc.dept, loc.muni, loc.lat, loc.lng, loc.zone, cityZone, true, loc.precise);
        }
      });
    },

    _reclassifySavedLocation: function(loc) {
      var self = this;
      if (!loc || !loc.confirmed || typeof loc.lat !== 'number' || typeof loc.lng !== 'number') return;
      var config = this.getConfig();
      if (!config) return;
      var version = this._locationVersion;
      var destinationVersion = this._destinationVersion;
      findDeliveryZone(loc.lat, loc.lng, config).then(function(zoneInfo) {
        // Never let an old cookie/classification overwrite a newer header,
        // map, or GPS update.
        if (self._location !== loc || self._locationVersion !== version ||
            self._destinationVersion !== destinationVersion) return;
        self.setLocation(
          zoneInfo.departamento || loc.dept,
          zoneInfo.municipio || loc.muni,
          loc.lat,
          loc.lng,
          zoneInfo.zone,
          zoneInfo.cityZone,
          true,
          loc.precise
        );
      }).catch(function() {
        // A failed coverage lookup must not turn a saved location into a
        // guessed messenger or cargo route.
        if (self._location === loc && self._locationVersion === version &&
            self._destinationVersion === destinationVersion && loc.zone !== 'unknown') {
          self.setLocation(loc.dept, loc.muni, loc.lat, loc.lng, 'unknown', loc.cityZone, true, loc.precise);
        }
      });
    },

    syncCoverageLocation: function(snapshot) {
      if (!snapshot) return;
      var revision = Number(snapshot.revision);
      if (!isNaN(revision)) {
        if (revision < this._coverageRevision) return;
        this._coverageRevision = revision;
      }

      var incoming = snapshot.location;
      var validIncoming = incoming && incoming.confirmed === true && incoming.precise === true &&
        typeof incoming.lat === 'number' && typeof incoming.lng === 'number';
      if (!validIncoming) {
        // A cart invalidation must immediately make any older cookie lookup
        // ineligible to write its result after the invalidation.
        this._destinationVersion++;
        return;
      }

      var current = this.getLocation();
      var samePoint = current && current.lat === incoming.lat && current.lng === incoming.lng;
      var zone = normalizeCoverageZone(snapshot.coverage || snapshot, samePoint ? current.muni : null);
      if (samePoint && current.confirmed && current.precise && current.zone === zone &&
          current.dept !== 'unknown' && current.muni !== 'unknown') return;

      // The coverage engine is also used directly by cart flows. It does not
      // own cv_location, so copy an exact confirmed cart destination here.
      // This write is intentionally silent: echoing cv:location-changed back
      // into setDestination would create a pending/verified event loop.
      if (!samePoint) this._destinationVersion++;
      this.setLocation(
        samePoint && current.dept ? current.dept : 'unknown',
        samePoint && current.muni ? current.muni : 'unknown',
        incoming.lat,
        incoming.lng,
        zone,
        samePoint ? current.cityZone : undefined,
        true,
        true,
        true,
        true
      );
      this._resolveCoverageLabels(incoming.lat, incoming.lng);
    },

    _resolveCoverageLabels: function(lat, lng) {
      var self = this;
      var config = this.getConfig();
      var request = ++this._coverageLabelRequest;
      var destinationVersion = this._destinationVersion;
      if (!config) {
        if (this._location && this._location.lat === lat && this._location.lng === lng) {
          fireCoverageSyncedLocationEvent(this._location);
        }
        return;
      }
      findDeliveryZone(lat, lng, config).then(function(zoneInfo) {
        if (request !== self._coverageLabelRequest || self._destinationVersion !== destinationVersion ||
            !self._location || self._location.lat !== lat || self._location.lng !== lng) return;
        self.setLocation(
          zoneInfo.departamento || 'unknown',
          zoneInfo.municipio || 'unknown',
          lat,
          lng,
          zoneInfo.zone || 'unknown',
          zoneInfo.cityZone,
          true,
          true,
          true,
          true
        );
        fireCoverageSyncedLocationEvent(self._location);
      }).catch(function() {
        if (request !== self._coverageLabelRequest || self._destinationVersion !== destinationVersion ||
            !self._location || self._location.lat !== lat || self._location.lng !== lng) return;
        // Municipality lookup is only a label lookup. Keep the engine's
        // verified route, but make an unavailable place explicit instead of
        // borrowing labels from Guatemala/default coordinates.
        self.setLocation(
          'unknown',
          'unknown',
          lat,
          lng,
          self._location.zone || 'unknown',
          undefined,
          true,
          true,
          true,
          true
        );
        fireCoverageSyncedLocationEvent(self._location);
      });
    },

    init: function() {
      var self = this;
      var existing = this.getLocation();
      if (existing && existing.dept && existing.muni && existing.confirmed) {
        // Do not expose a cached route while the shared engine verifies it.
        // Keep the coordinates/labels so the reclassification can replace
        // only the route with the current coverage result.
        existing.zone = 'unknown';
        setCookie(COOKIE_NAME, existing, COOKIE_DAYS);
        this._ready = true;
        this._applyLocationBodyClass();
        this._updateHeaderBadge(existing);
        fireLocationEvent(existing);
        this._reclassifySavedLocation(existing);
        this._ensureCityZone();
      } else {
        var shown = this._showLocationPopup();
        if (!shown) {
          var loc = { dept: DEFAULT_LOCATION.dept, muni: DEFAULT_LOCATION.muni, lat: DEFAULT_LOCATION.lat, lng: DEFAULT_LOCATION.lng, zone: DEFAULT_LOCATION.zone, confirmed: false };
          self._location = loc;
          self._updateHeaderBadge(loc);
          fireLocationEvent(loc);
          self._ready = true;
        }
      }
    }
  };

  CelovendoLocation._defaultLocation = DEFAULT_LOCATION;
  window.CelovendoLocation = CelovendoLocation;
  window.CelovendoGeo = {
    pointInPolygon: pointInPolygon,
    pointInGeometry: pointInGeometry,
    loadGeoJSON: loadGeoJSON,
    findDeliveryZone: findDeliveryZone,
    getCentroid: getCentroid,
    calculateEstimate: calculateEstimate,
    formatDate: formatDate,
    getNowGT: getNowGT,
    parseBusinessHours: parseBusinessHours,
    nextBusinessOpen: nextBusinessOpen,
    addBusinessDays: addBusinessDays
  };

  document.addEventListener('DOMContentLoaded', function() {
    CelovendoLocation.init();
  });
  document.addEventListener('cv:coverage-changed', function(e) {
    CelovendoLocation.syncCoverageLocation(e && e.detail);
  });
})();
